import { compose, setDisplayName, lifecycle } from 'react-recompose';

import { getResults } from '~/state/ducks/app/selectors.js';
import { getSuperPortalList } from '~/state/ducks/organizations/operations.js';
import withReduxConnect from '~/views/enhancers/withReduxConnect.js';

import Search from '../components/Search.jsx';


export default compose(
    setDisplayName('Search'),
    withReduxConnect({
        mapStateToProps: state => ({
            data: getResults(state),
        }),
        mapDispatchToProps: {
            onFetch: getSuperPortalList,
        },
    }),
    lifecycle({
        componentDidMount() {
            this.props.onFetch();
        },
    }),
)(Search);
